import { SxProps, Theme } from '@mui/material';

export const tabsSx = {
    borderRadius: '10px',
    background: '#EDF0F3',
    boxShadow: 'rgba(0, 0, 0, 0.20) 0px 0.5px 2px 0px inset',
    backdropFilter: 'blur(16px)',
    p: '2px',
    mb: 2,

    '& .MuiTabs-flexContainer': {
        gap: 1,
    },

    '& .MuiTab-root': {
        py: 0.5,
        px: 2,
        color: (theme) => `${theme.palette.dark.main} !important`,
        transition: 'color 0.25s ease-in-out',

        '& .MuiTab-iconWrapper': {
            color: (theme) => `${theme.palette.secondary.main} !important`,
            transition: 'color 0.25s ease-in-out',
            width: 16,
            height: 16,
        },

        '&.Mui-selected': {
            color: (theme) => `${theme.palette.body.main} !important`,

            '& .MuiTab-iconWrapper': {
                color: (theme) => `${theme.palette.primary.main} !important`,
            },
        },
    },
} as const satisfies SxProps<Theme>;
